import Checkbox from "@material-ui/core/Checkbox";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import { Test } from "../../graphql/baseTypes";
import { StyledTableCell } from "../Table";
type TestKeys = keyof Test;

export const columns: Array<{
  id: TestKeys;
  label: string;
  minWidth?: number;
  align?: "inherit" | "left" | "center" | "right" | "justify";
}> = [
  {
    id: "company",
    label: "Auftraggeber",
    minWidth: 80,
    align: "left",
  },
  {
    id: "location",
    label: "Standort",
    minWidth: 80,
    align: "left",
  },
  { id: "testId", label: "Test-ID", minWidth: 20 },

  { id: "date", label: "Datum", minWidth: 80 },
  { id: "userId", label: "Benutzer", minWidth: 80 },
  { id: "result", label: "Ergebnis", minWidth: 80 },
];
interface EnhancedTableProps {
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowCount: number;
}
const EnhancedTableHead: React.FC<EnhancedTableProps> = (props) => {
  const { onSelectAllClick, numSelected, rowCount } = props;

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            color={"primary"}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </StyledTableCell>
        {columns.map((column) => (
          <StyledTableCell
            key={column.id}
            align={column.align}
            style={{ minWidth: column.minWidth }}
          >
            {column.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
